import './close-report-screen.scss'

import { faArrowLeft, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FormApi } from 'final-form';
import { get, set } from 'lodash';
import Component from 'vue-class-component';

import { ConditionReport, ConditionReportDataStore } from '@skinsoft/entity';
import { id, referenceNumber } from '@skinsoft/entity/src/condition-report/selectors';
import { ConditionReportPDFTransferHelper, MediaTransferHelper } from '@skinsoft/media-transfer-helper';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { SearchFeatured } from '@skinsoft/ui';

import { CLOSE_CLOSE_REPORT_SCREEN_TOPIC } from '../../../busTopics';
import { router, Routes } from '../../../router';
import { ConditionReportPDFGenerator } from '@skinsoft/entity';
import { EMPTY, Observable, of } from 'rxjs';
import { SignerInputCard } from '../signature-module/signer-input-card';
import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics';

@Component({
    props: ['conditionReport', 'searchFeatured', 'fieldName', "form"],
    template: require('./close-report-screen.html')
})
export class CloseReportScreen extends ReactiveVue {

    public conditionReport: ConditionReport;
    public searchFeatured: SearchFeatured;
    public fieldName: string;
    public form: FormApi;

    // Icons
    private backIcon = faArrowLeft;
    private checkIcon = faCheck;

    private $conditionReportDataStore: ConditionReportDataStore;
    private $conditionReportPDFTransferHelper: ConditionReportPDFTransferHelper
    private $conditionReportPDFGenerator: ConditionReportPDFGenerator

    private closingStatus: string = "";
    private closingInProgress: boolean = false;

    private closeCloseReportScreen() {
        this.emitOnBus(CLOSE_CLOSE_REPORT_SCREEN_TOPIC)
    }

    private async handleCloseReport() {
        this.closingInProgress = true;
        this.closingStatus = this.$t('closeReportScreen.fileGeneration') as string;

        const hasCachedChanges = await this.$conditionReportDataStore.hasCachedUpdates(this.conditionReport.id)
        if(window.navigator.onLine && !hasCachedChanges) {
            this.$conditionReportPDFGenerator.generatePDF(this.conditionReport, this.searchFeatured, async (blob) => {
                this.closingStatus = this.$t('closeReportScreen.transferingFile') as string;
    
                const fileName = referenceNumber(this.conditionReport) ? `${referenceNumber(this.conditionReport)}.pdf` : `${MediaTransferHelper.generateMediaHash()}.pdf`
                const withName = new File([blob], fileName)
    
                this.$conditionReportPDFTransferHelper.uploadPDFDocument("application/pdf", this.conditionReport.id, withName, true)
                    .subscribe(async (mediaId: string) => {
                        this.closingStatus = this.$t('closeReportScreen.reportClosing') as string;
        
                        if(mediaId) {
                            await this.$conditionReportDataStore.closeConditionReport(id(this.conditionReport), mediaId)
                        }
                        else {
                            await this.$conditionReportDataStore.closeConditionReportOffline(id(this.conditionReport))
                        }
            
                        // Going back to closed report screen
                        router.push({ name: Routes.CLOSE_REPORTS });
                        this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                            message: this.$t('closeReportScreen.notificationContent', { referenceNumber: referenceNumber(this.conditionReport) }),
                            variant: "success"
                        })
                    })
            })
            .catch(e => {
                const alertPayload = {
                    message: this.$t('pdfDocument.generationFailureAlert'),
                    variant: 'danger'
                };
                this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
            })
            
        } else {
            await this.$conditionReportDataStore.closeConditionReportOffline(id(this.conditionReport))
            // Going back to closed report screen
            router.push({ name: Routes.CLOSE_REPORTS });
            this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                message: this.$t('closeReportScreen.notificationContent', { referenceNumber: referenceNumber(this.conditionReport) }),
                variant: "success"
            })
        }
    }
}